import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import App from './App';
import { store } from './app/store';
import './index.css';
import { worker } from './mocks/worker';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root')!;
const root = createRoot(container);
const router = createBrowserRouter([{ path: '*', Component: App }]);

function render() {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </React.StrictMode>,
  );
}

// Only register the mock service worker in seed/mock mode. Outside it the app
// talks to the real backend, so starting MSW would just add a failed SW
// registration (e.g. over a tunnel where the worker script isn't served).
if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_USE_MOCKS === 'true'
) {
  worker.start({ onUnhandledRequest: 'bypass' }).finally(render);
} else {
  render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
